module.exports = __webpack_public_path__ + "static/js/2.9f10c181.chunk.worker.js"